// extracted by mini-css-extract-plugin
export default {"custom_breadcrumb":"CustomBreadcrumb_custom_breadcrumb__7jIuK"};